var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"4"}},[_c('div',{style:(_vm.style)},[_vm._v(" Página não encotrada")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }